/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable no-undef */
import { ReactComponent as CloseIcon } from 'assets/icons/close_square.svg';
import { IDataPages, IDataProducts } from 'common/contracts';
import {
  LoadingWrap,
  ModalBodyContent,
  ModalCloseBtn,
  ModalContainer,
  ModalImageWrap
} from 'common/styles/Modal.styles';
import {
  BodyContent,
  Container,
  ContentHeader,
  ContentWrapper,
  DetailsContentWrapper,
  HeaderWrapper,
  ImageWrap,
  LeftContent,
  ListItem,
  ListWrapper,
  ProductNameBox,
  TechnicalDetails,
  TechnicalDetailsLink
} from 'common/styles/SecondaryModalProduct.style';
import Breadcrumb from 'components/BreadCrumb/Breadcrumb';
import ContactUs from 'components/Buttons/ContactUs/ContactUs';
import LogoIcon from 'components/LogoIcon/LogoIcon';
import { pageData } from 'data/pages';
import { productsData } from 'data/products';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { toCamelCase } from 'utils/callbacks';
import CommonUtils from 'utils/common';

const Product = ({ id }: { id: string }) => {
  const { params } = useRouteMatch<{ facility: string; room: string; product: string }>();
  const history = useHistory();
  // const { pathname } = useLocation();

  // const [productList, setProductList] = useState<IDataProducts[]>([]);
  const [currentProduct, setCurrentProduct] = useState<IDataProducts>();
  const [currentFacility, setCurrentFacility] = useState<IDataPages>();

  useEffect(() => {
    // Find current products
    const currP = productsData.find(item => item.id === params.product || item.id === id);

    const currentFacilityPage = pageData.find(item => item.route === params.facility);

    setCurrentProduct(currP);
    setCurrentFacility(currentFacilityPage);

    // filter products of room

    // const p = productsData.filter(item => item.roomRoute === params.room && item.facilityRoute === params.facility);

    // setProductList(p);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      {currentProduct ? (
        <ModalContainer>
          <LogoIcon />
          <ModalImageWrap onClick={() => history.push(CommonUtils.path(history.location.pathname))}>
            <img
              src={
                // eslint-disable-next-line global-require
                require(`../../../assets/images/rooms/${currentFacility?.route}/${currentFacility?.backgroundImage}`)
                  .default
              }
              alt={currentFacility?.title}
            />
          </ModalImageWrap>
          <ModalBodyContent open animation="zoom-in">
            <Container ref={containerRef}>
              <ModalCloseBtn
                onClick={() => {
                  history.push(CommonUtils.path(history.location.pathname));
                }}
              >
                <CloseIcon />
              </ModalCloseBtn>
              <Breadcrumb
                breadcrumbs={[
                  {
                    title: 'Home',
                    link: '/',
                    active: false
                  },
                  {
                    title: toCamelCase(params.facility),
                    link: `/${params.facility}`,
                    active: false,
                    handler: () => {
                      history.push(CommonUtils.path(`/${params.facility}/${currentProduct.roomRoute}`));
                    }
                  },
                  {
                    title: toCamelCase(currentProduct.roomRoute),
                    link: `/${params.facility}/${currentProduct.roomRoute}`,
                    active: false,
                    handler: () => {
                      history.push(CommonUtils.path(history.location.pathname));
                    }
                  },
                  {
                    title: currentProduct.title,
                    link: '',
                    active: true
                  }
                ]}
              />
              <HeaderWrapper>
                <ProductNameBox>{currentProduct.title}</ProductNameBox>
              </HeaderWrapper>

              <ContentWrapper>
                <LeftContent>
                  <DetailsContentWrapper>
                    <ContentHeader>{currentProduct.title}</ContentHeader>
                    <BodyContent>
                      {currentProduct.content === [] ? (
                        <>
                          <p>
                            The OGS 3 family is our 4th generation gas sampling systems, relied on by major operators
                            around the world. Built to withstand the harshest conditions, the Omicron Gas Sampling
                            Systems are the ideal solution for gas detection in areas where normal installation of gas
                            sensors is impossible.
                          </p>
                          <p>
                            Our OGS 3 family consists of two different gas sampling systems; The OGS 3.11 is the ideal
                            gas sampling system for all typical marine applications. Based on our more than 20 years of
                            experience we have optimized the system to meet the demanding maritime conditions and to
                            become the all-round solution for monitoring the air content in e.g. water ballast tanks,
                            pump rooms or void spaces in the cargo area.
                          </p>
                        </>
                      ) : (
                        currentProduct.content
                      )}
                    </BodyContent>

                    <ListWrapper>
                      {currentProduct.featureList.map((listItem: string, i: number) => (
                        <ListItem key={i}>{listItem}</ListItem>
                      ))}
                    </ListWrapper>
                  </DetailsContentWrapper>

                  <ContactUs />

                  <TechnicalDetails>Check Technical Part</TechnicalDetails>

                  <TechnicalDetailsLink href={currentProduct.link} target="_blank" rel="noopener">
                    {currentProduct.link}
                  </TechnicalDetailsLink>
                </LeftContent>
                <ImageWrap>
                  <img
                    src={
                      // eslint-disable-next-line global-require
                      require(`../../../assets/images/products/${currentProduct.productImage}`).default
                    }
                    alt={currentProduct.title}
                  />
                </ImageWrap>
              </ContentWrapper>
            </Container>
          </ModalBodyContent>
        </ModalContainer>
      ) : (
        <LoadingWrap>Loading</LoadingWrap>
      )}
    </>
  );
};

export default Product;
